<script setup lang="ts">
import Privilege from './Privilege.vue'

const { showExpried } = useExpired()
function onClose() {
  showExpried.value = false
}
</script>

<template>
  <a-modal
    v-model:visible="showExpried"
    :width="600"
    simple hide-title
    :footer="false"
    :mask-closable="false"
    unmountOnClose
    modal-class="rd-16 p-0"
  >
    <Privilege :can-close="true" @close="onClose" />
  </a-modal>
</template>

<style lang="less">

</style>
